export default class WaFetchError extends Error
{
  response = null;

  responseJSON = null;
}
